import { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import Logo from './Logo';
import { useLang } from '../context/LangContext';
import './Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen]         = useState(false);
  const { lang, setLang, t }    = useLang();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`navbar${scrolled ? ' navbar--scrolled' : ''}${lang === 'ar' ? ' navbar--rtl' : ''}`}>
      <div className="navbar__inner container">
        <Link to="/" className="navbar__logo"><Logo lang={lang} /></Link>

        <ul className={`navbar__links${open ? ' open' : ''}`}>
          <li><NavLink to="/"        onClick={() => setOpen(false)}>{t('nav.home')}</NavLink></li>
          <li><NavLink to="/features" onClick={() => setOpen(false)}>{t('nav.features')}</NavLink></li>
          <li><NavLink to="/partner"    onClick={() => setOpen(false)}>{t('nav.partner')}</NavLink></li>
          <li><NavLink to="/driver-app" onClick={() => setOpen(false)}>Rider App</NavLink></li>
          <li><NavLink to="/pricing"    onClick={() => setOpen(false)}>Pricing</NavLink></li>
          <li><NavLink to="/about"      onClick={() => setOpen(false)}>{t('nav.about')}</NavLink></li>
          <li><NavLink to="/contact"  onClick={() => setOpen(false)}>{t('nav.contact')}</NavLink></li>
          <li className="mobile-only">
            <button
              className="lang-toggle"
              onClick={() => setLang(lang === 'en' ? 'ar' : 'en')}
              aria-label="Toggle language"
            >
              {lang === 'en' ? 'عربي' : 'EN'}
            </button>
          </li>
          <li className="mobile-only">
            <Link to="/contact" className="btn-primary mobile-cta" onClick={() => setOpen(false)}>
              {t('nav.getStarted')}
            </Link>
          </li>
        </ul>

        <div className="navbar__actions">
          <button
            className="lang-toggle"
            onClick={() => setLang(lang === 'en' ? 'ar' : 'en')}
            aria-label="Toggle language"
          >
            {lang === 'en' ? 'عربي' : 'EN'}
          </button>
          <Link to="/contact" className="btn-primary">{t('nav.getStarted')}</Link>
        </div>

        <button className={`navbar__burger${open ? ' is-open' : ''}`} onClick={() => setOpen(!open)} aria-label="menu">
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}
